import { apiCall } from "@/api/client";
import type { ListRecentDeploymentsResponse } from "@/types/api";

// Global task feed — the most recent deployments across every tenant, newest
// first (backed by the sparse ``by_deployment_time`` GSI server-side). Powers
// the shell's bottom task panel. Tenant-scoped history stays in
// ``listDeployments`` (api/tenants.ts).
export function listRecentDeployments(token: string, opts?: { limit?: number }) {
  const qs = opts?.limit ? `?limit=${opts.limit}` : "";
  return apiCall<ListRecentDeploymentsResponse>(`/deployments${qs}`, { token });
}
